<template>
    <div class="distributor-article-list">
        <div class="common-header-wrap">
            <mt-header :title="article_title" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="right_bottom" v-if="pay_status==0" @click="confirmSumit()"> 购买</div>
        <div class="content" v-html='article_content'></div>
    </div>
</template>
<script>
    import { getInsuranceDetail } from '../../../api/member'
    import { Toast } from 'mint-ui'
    export default {
        name: 'HomeDocument',
        data () {
            return {
                pay_status: 0,
                id: 0,
                article_title: '',
                article_content: ''
            }
        },
        created: function () {
            this.id = this.$route.query.id;
            getInsuranceDetail(this.id).then(res => {
                this.pay_status = res.result.pay_status
                this.article_title = res.result.name
                this.article_content = res.result.content
            }).catch(function (error) {
                Toast(error.message)
            })
        },
        methods: {
            confirmSumit () {
                this.$router.push({ name: 'MemberInsurance', query: { id: this.id } })
            }
        }
    }
</script>
<style  lang="scss" scoped>
    .content{padding:.5rem;font-size:.7rem;line-height:1rem;}
    div.right_bottom{
        background: #b74011;
        color:#ffffff;
        overflow: hidden;
        z-index: 9999;
        position: fixed;
        padding:5px;
        text-align:center;
        width: 2.5rem;
        height: 1.5rem;
        line-height: 1.5rem;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        right: 10px;
        bottom: 10px;
    }
</style>
